import { type RecType } from '@/defs/rec'
import { cn } from '@/utils/commonUtil'

import styles from './CardControls.module.scss'
import { CardControlsArt } from './CardControlsArt/CardControlsArt'
import { CardControlsClipboard } from './CardControlsClipboard/CardControlsClipboard'
import { CardControlsModal } from './CardControlsModal/CardControlsModal'

type Props = {
  controls?: 'left' | 'right'
  disableModal?: boolean
  rec: RecType
}

export const CardControls = ({ controls = 'right', disableModal, rec }: Props) => (
  <ul className={cn(styles.container, { controls, styles })}>
    <CardControlsArt rec={rec} />
    <CardControlsClipboard rec={rec} />
    {!disableModal && <CardControlsModal rec={rec} />}
  </ul>
)
